import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentTabs, ContentTabSpec, useAuth, useModal } from '@shapeable/ui';
import { AiUpperCaseIconGlyph } from '@shapeable/icons';
import { EventView } from '../../types';
import { compact } from 'lodash';
import { Event } from '@shapeable/gesda-types';
import { useEventViewDefinition } from '../../hooks/use-event-view-definition';
import { useEntityUserPermission } from '../../hooks/use-entity-user-permission';
import { AiChatInterfaceModal } from '../elements/ai-chat-interface-modal';

const cls = classNames('event-tabs-layout');

// -------- Types -------->

// -------- Props -------->

export type EventTabsLayoutProps = Classable & HasChildren & { 
  entity?: Event;
  activeView?: EventView;
  setActiveView?: (view: EventView) => void;
};

export const EventTabsLayoutDefaultProps: Omit<EventTabsLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const TabsStyles = breakpoints({
  base: css`
  
  `,
});

// -------- Components -------->

const My = {
  Tabs: styled(ContentTabs)<ContainerProps>`${TabsStyles}`,
};

export const EventTabsLayout: Shapeable.FC<EventTabsLayoutProps> = (props) => {
  const { className, children, entity, activeView, setActiveView } = props;

  const { color, documentsDescription } = entity;
  const auth = useAuth();

  const { isLoading, permissions } = useEntityUserPermission();
  const { canViewDocuments } = permissions;

  const { hasKeyTakeaways, hasOverview, hasSessions } = useEventViewDefinition(entity);

  const hasDocuments = !!documentsDescription?.text;

  const tabs: ContentTabSpec<EventView>[] = compact([
    {
      id: 'radar-ai',
      icon: <AiUpperCaseIconGlyph />,
    },
    hasKeyTakeaways &&
    {
      id: 'key-takeaways',
      label: 'Key Takeaways',
    },
    hasOverview &&
    {
      id: 'overview',
      label: 'Overview',
    },
    hasSessions &&
    {
      id: 'sessions',
      label: 'Sessions',
    },
    hasDocuments && !isLoading && canViewDocuments &&
    {
      id: 'resources',
      label: 'Resources',
    }
  ]);
  
  const modal = useModal();
        
  const handleChatClick = () => {
    modal?.show(<AiChatInterfaceModal />, { color: '#000000', title: 'RadarAI', opacity: 0.5 });
  };

  const handleTabClick = (tabId: EventView) => {
    if (tabId === 'radar-ai') {
      handleChatClick();
    } else {
      setActiveView(tabId);
    }
  };
  
  return (
    <My.Tabs onTabClick={handleTabClick} activeTab={activeView} items={tabs} colors={{ border: color?.value }} />
  )
};

EventTabsLayout.defaultProps = EventTabsLayoutDefaultProps;
EventTabsLayout.cls = cls;